function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/text
 */
import Node from './node';
/**
 * Tree view text node.
 *
 * The constructor of this class should not be used directly. To create a new text node instance
 * use the {@link module:engine/view/downcastwriter~DowncastWriter#createText `DowncastWriter#createText()`}
 * method when working on data downcasted from the model or the
 * {@link module:engine/view/upcastwriter~UpcastWriter#createText `UpcastWriter#createText()`}
 * method when working on non-semantic views.
 *
 * @extends module:engine/view/node~Node
 */

var Text = /*#__PURE__*/function (_Node) {
  _inherits(Text, _Node);

  var _super = _createSuper(Text);

  /**
   * Creates a tree view text node.
   *
   * @protected
   * @param {module:engine/view/document~Document} document The document instance to which this text node belongs.
   * @param {String} data The text's data.
   */
  function Text(document, data) {
    var _this;

    _classCallCheck(this, Text);

    _this = _super.call(this, document);
    /**
     * The text content.
     *
     * Setting the data fires the {@link module:engine/view/node~Node#event:change:text change event}.
     *
     * @protected
     * @member {String} module:engine/view/text~Text#_textData
     */

    _this._textData = data;
    return _this;
  }
  /**
   * Checks whether this object is of the given type.
   *
   *		text.is( '$text' ); // -> true
   *		text.is( 'node' ); // -> true
   *		text.is( 'view:$text' ); // -> true
   *		text.is( 'view:node' ); // -> true
   *
   *		text.is( 'model:$text' ); // -> false
   *		text.is( 'element' ); // -> false
   *		text.is( 'range' ); // -> false
   *
   * {@link module:engine/view/node~Node#is Check the entire list of view objects} which implement the `is()` method.
   *
   * **Note:** Until version 20.0.0 this method wasn't accepting `'$text'` type. The legacy `'text'` type is still
   * accepted for backward compatibility.
   *
   * @param {String} type Type to check.
   * @returns {Boolean}
   */


  _createClass(Text, [{
    key: "is",
    value: function is(type) {
      return type === '$text' || type === 'view:$text' || // This are legacy values kept for backward compatibility.
      type === 'text' || type === 'view:text' || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
      type === 'node' || type === 'view:node';
    }
    /**
     * The text content.
     *
     * @readonly
     * @type {String}
     */

  }, {
    key: "data",
    get: function get() {
      return this._textData;
    }
    /**
     * The `_data` property is controlled by a getter and a setter.
     *
     * The getter is required when using the addition assignment operator on protected property:
     *
     *		const foo = downcastWriter.createText( 'foo' );
     *		const bar = downcastWriter.createText( 'bar' );
     *
     *		foo._data += bar.data;   // executes: `foo._data = foo._data + bar.data`
     *		console.log( foo.data ); // prints: 'foobar'
     *
     * If the protected getter didn't exist, `foo._data` will return `undefined` and result of the merge will be invalid.
     *
     * The setter sets data and fires the {@link module:engine/view/node~Node#event:change:text change event}.
     *
     * @protected
     * @type {String}
     */

  }, {
    key: "_data",
    get: function get() {
      return this.data;
    },
    set: function set(data) {
      this._fireChange('text', this);

      this._textData = data;
    }
    /**
     * Checks if this text node is similar to other text node.
     * Both nodes should have the same data to be considered as similar.
     *
     * @param {module:engine/view/text~Text} otherNode Node to check if it is same as this node.
     * @returns {Boolean}
     */

  }, {
    key: "isSimilar",
    value: function isSimilar(otherNode) {
      if (!(otherNode instanceof Text)) {
        return false;
      }

      return this === otherNode || this.data === otherNode.data;
    }
    /**
     * Clones this node.
     *
     * @protected
     * @returns {module:engine/view/text~Text} Text node that is a clone of this node.
     */

  }, {
    key: "_clone",
    value: function _clone() {
      return new Text(this.document, this.data);
    } // @if CK_DEBUG_ENGINE // toString() {
    // @if CK_DEBUG_ENGINE // 	return `#${ this.data }`;
    // @if CK_DEBUG_ENGINE // }
    // @if CK_DEBUG_ENGINE // log() {
    // @if CK_DEBUG_ENGINE // 	console.log( 'ViewText: ' + this );
    // @if CK_DEBUG_ENGINE // }
    // @if CK_DEBUG_ENGINE // logExtended() {
    // @if CK_DEBUG_ENGINE // 	console.log( 'ViewText: ' + this );
    // @if CK_DEBUG_ENGINE // }

  }]);

  return Text;
}(Node);

export { Text as default };